import React from 'react';
import types from 'prop-types';
import styled from 'react-emotion';
import {Container, Header} from 'semantic-ui-react';
import DocumentationSearchForm from '../dashboard/DocumentationSearchForm';

import Layout, * as styles from './Layout';
import {colors} from '../../styles';
import {lighten} from 'polished';

const Page = Layout;

const PageHeaderWrapper = styled.div`
  padding: 35px 45px 10px;
  margin-right: -45px;
  margin-left: -45px;
  margin-top: -15px;
  min-height: 100px;
  background-color: ${colors.headerBackground};

  @media (max-width: 650px) {
    padding: 25px 15px 10px;
    margin-right: -15px;
    margin-left: -15px;
  }

  .ui.header {
    color: ${colors.textLabel};
  }
`;

const PageSecondaryHeaderWrapper = styled.div`
  padding: 0 45px;
  margin: 0 -45px 10px;
  height: 44px;
  background-color: ${colors.headerBackground};

  @media (max-width: 650px) {
    margin: 0 -15px 10px;
  }

  .ui.secondary.pointing.menu {
    height: 44px;
    border-bottom: 2px solid ${colors.headerBackground};

    font-size: 0.9rem;

    .item {
      text-transform: uppercase;
      font-weight: bold;
      color: ${lighten(0.1, colors.textLabel)};

      &.active {
        color: #444;
      }
    }
  }
`;

const WrapperComponent = ({fluid, children}) => {
  return <Container fluid>{children}</Container>;
};

Page.Header = ({children, fluid, className, ...rest}) => (
  <PageHeaderWrapper className={className}>
    <WrapperComponent fluid={fluid}>
      <Header as="h1" {...rest}>
        {children}
      </Header>
    </WrapperComponent>
  </PageHeaderWrapper>
);

Page.Secondary = ({children, fluid, className, ...rest}) => (
  <PageSecondaryHeaderWrapper className={className}>
    <WrapperComponent fluid={fluid}>{children}</WrapperComponent>
  </PageSecondaryHeaderWrapper>
);

Page.HeaderActions = styled.div`
  ${styles.box};

  .ui.input > input {
    font-size: 1.1rem;
  }

  .ui.header & {
    .button.icon:only-child {
      display: block;
      padding: 0.78571429em;
      margin-right: 0em !important;
    }
  }
`;

Page.FillTitle = styled(Page.Fill)`
  align-items: flex-start;
  display: flex;
`;

Page.HeaderWithActions = ({title, children, className}) => (
  <Page.Flex
    className={className}
    css={{
      '@media (max-width: 849px)': {
        flexWrap: 'wrap',
        flexDirection: 'column-reverse',
        '.header-title, .header-actions': {
          justifyContent: 'center',
          marginTop: '10',
        },
      },
      '@media (max-width: 570px)': {
        '.ui.form .inline.fields > label': {
          display: 'block',
          width: '100%',
        },
      },
    }}
  >
    <Page.FillTitle className="header-title">{title}</Page.FillTitle>
    <Page.Flex className="header-actions">
      <Page.HeaderActions>{children}</Page.HeaderActions>
    </Page.Flex>
  </Page.Flex>
);

Page.HeaderWithActions.propTypes = {
  title: types.node.isRequired,
  children: types.node.isRequired,
};

Page.Content = styled.div`
  flex: 1;
  position: relative;
  overflow-y: auto;
  padding: 15px;
`;

Page.Basic = ({title, secondary, children, fluid, className}) => (
  <Page className={className}>
    <Page.Fill scroll className="page-fill">
      <Page.Header fluid={fluid}>
        <Page.HeaderWithActions title={title}>
          <DocumentationSearchForm />
        </Page.HeaderWithActions>
      </Page.Header>
      <Page.Secondary fluid={fluid}>{secondary}</Page.Secondary>
      <WrapperComponent fluid={fluid}>{children}</WrapperComponent>
    </Page.Fill>
  </Page>
);

Page.Basic.propTypes = {
  title: types.node,
  children: types.node.isRequired,
};

export default Page;
